module.exports = __webpack_public_path__ + "media/images/personnel/Jeanine_M-5b27f049437ac82b139f4071a8513743.png";